import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Tabs } from 'components/DesignSystem/Tabs/Tabs';
import {
    IMAGE_UPLOADER_TAB_FROM_URL,
    IMAGE_UPLOADER_TAB_UPLOAD,
    type ImageUploaderSourceTab,
} from 'components/widgets/ImageUploader/ImageUploader.logic';
import classes from 'components/widgets/ImageUploader/component/ImageUploaderTabs/ImageUploaderTabs.module.scss';

interface ImageUploaderTabsProps {
    value: ImageUploaderSourceTab;
    onChange: (value: ImageUploaderSourceTab) => void;
}

export const ImageUploaderTabs = ({ value, onChange }: ImageUploaderTabsProps) => {
    return (
        <div className={classes.root}>
            <Tabs
                variant={'navigation'}
                value={value}
                onChange={(v) => onChange(v as ImageUploaderSourceTab)}
                tabs={[
                    {
                        value: IMAGE_UPLOADER_TAB_UPLOAD,
                        label: 'Upload',
                        icon: <MuiIcon icon={'cloud_upload'} type={'outlined'} fontSize={'3rem'} color={'inherit'} />,
                    },
                    {
                        value: IMAGE_UPLOADER_TAB_FROM_URL,
                        label: 'From URL',
                        icon: <MuiIcon icon={'link'} type={'outlined'} fontSize={'3rem'} color={'inherit'} />,
                    },
                ]}
            />
        </div>
    );
};
